import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import MenuItem  from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ReliefForm from '../reliefform/ReliefForm'
import logocombank from '../../images/combank-logo.png'; 
import '../../css/styles.css';
import HeaderComponent from '../header/HeaderComponent';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    backgroundColor: '#ffffff',
    [theme.breakpoints.up('md')]: {
      background:"#ffffff"
    },
    [theme.breakpoints.up('lg')]: {
      background:"#ffffff"
    },
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      background:"#ffffff"
    },
  },
  menuButton: {
    backgroundColor: '#006fb7',
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  selected: {
    backgroundColor: '#d0d3f5 !important',
   // color: "blue",
  },
}));

function FormsPortal(props) {
  const { container } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
        {['Relief Form'].map((text, index) => (
          //<ListItem button key={text}>
            <MenuItem button selected key={text} classes={{ selected: classes.selected }}>
            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text} />
            </MenuItem>
          //</ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
    
     
      <CssBaseline />
      <div className="app-bar">
      
      <AppBar position="fixed" className={classes.appBar}>
      <HeaderComponent></HeaderComponent> 
      
      
      {/* <div className="logo">
          <a href="/" title="Commercial Bank Sri Lanka" tabIndex="41"><img src={logocombank} alt="Commercial Bank Sri Lanka" title="Commercial Bank Sri Lanka"/></a>
      </div> */}
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
             
            <MenuIcon />
            
          </IconButton>
          <Typography variant="h6" noWrap >
          
          {/* <div className="gredient_stripe">
            <div className="logo">
                  <a href="/" title="Commercial Bank Sri Lanka" tabIndex="41"><img src={logocombank} alt="Commercial Bank Sri Lanka" title="Commercial Bank Sri Lanka"/></a>
            </div>
          </div> */}
          </Typography>
        </Toolbar>
      
      </AppBar>
      
      </div>
      <nav className={classes.drawer} aria-label="forms list">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <ReliefForm></ReliefForm>
      </main>
    </div>
  );
}

FormsPortal.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  container: PropTypes.any,
};

export default FormsPortal;